/**
 * Artecs Kanagawa — theme entry.
 *
 * Drives the header SP drawer toggle. Keep this file minimal; section-level
 * behaviour belongs in dedicated entry files imported here when added.
 *
 * スクロール位置の復元は廃止。ロゴ/リロード/遷移を常にページ先頭から表示するため、
 * `history.scrollRestoration='manual'` は header.php の <head> 最早インラインで設定する
 * （遅延バンドルで設定するとブラウザが先に直前位置を復元し、一瞬チラつくため）。
 */

import '../css/header.css';
import '../css/footer.css';

(() => {
  const root = document.querySelector('.artecs-header');
  if (!root) {
    return;
  }

  const toggle = root.querySelector('[data-artecs-drawer-toggle]');
  const drawer = root.querySelector('[data-artecs-drawer]');
  if (!toggle || !drawer) {
    return;
  }

  const close = () => {
    root.classList.remove('is-drawer-open');
    toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
  };

  const open = () => {
    root.classList.add('is-drawer-open');
    toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
  };

  toggle.addEventListener('click', () => {
    if (root.classList.contains('is-drawer-open')) {
      close();
    } else {
      open();
    }
  });

  drawer.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', close);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      close();
    }
  });
})();

